// extracted by mini-css-extract-plugin
export default {"customSlideMenuWrapper":"DefaultMenu__customSlideMenuWrapper--2O_","customSlideMenu":"DefaultMenu__customSlideMenu--14b","backboneHeaderMenu":"DefaultMenu__backboneHeaderMenu--3OT"};